import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';
import './bin-photo';
import './bin-photo-modal';

class BinPhotoButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
      noPhoto: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      bn-icon {
        margin-right: .25em;
      }
      button {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.5);
        border: none;
        padding: 0;
        overflow: hidden;
        position: relative;
        cursor: pointer;
      }
      bin-photo {
        transition: .2s filter;
      }
      button:hover bin-photo {
        filter: brightness(0.6);
      }
      button[disabled] {
        pointer-events: none;
      }
      bn-icon {
        color: white;
        opacity: 0;
        position: absolute;
        font-size: 3em;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        transition: .2s opacity;
      }
      button:hover bn-icon {
        opacity: 1
      }
    `];
  }

  render() {
    return html`
      <button @click="${this._onClick}" ?disabled="${this.noPhoto}">
        <bin-photo .href="${this.href}"></bin-photo>
        <bn-icon name="fas fa-search"></bn-icon>
      </button>

      <bin-photo-modal
        .href="${this.href}"
        .hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
      ></bin-photo-modal>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    const photos = this.entity && this.entity.getSubEntitiesByRel('https://api.binsentry.com/rel/bin-photo');
    this.noPhoto = !photos || photos.length === 0;
  }
}

window.customElements.define('bin-photo-button', BinPhotoButton);
